import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslationService } from "@app/services/translation.service";
import './v-table-actions.component.scss';

@Component({
    selector: 'v-table-actions',
    template: require('./v-table-actions.component.html')
})
export class VTableActionsComponent {
    @Input() selectedItemsCount: number;
    @Input() subject: string = this.translationService.t('TableActions.Items');
    @Input() verb: string = this.translationService.t('TableActions.Configure');
    @Input() buttonString: string = "";
    @Input() disabled: boolean;
    @Output() apply: EventEmitter<void> = new EventEmitter<void>();

    //--

    label: string;

    constructor(
        private readonly translationService: TranslationService
    ) { }


    applyActions(): void {
        this.apply.emit();
    }
}
